import {
  IconAppsFilled,
  IconDeviceFloppy,
  IconTimeDuration30,
  IconUserPlus,
} from "@tabler/icons-react";

export const stepperAppointment = [
  {
    icon: <IconUserPlus />,
    label: "مشتری",
  },
  {
    icon: <IconAppsFilled />,
    label: "سرویس",
  },
  {
    icon: <IconTimeDuration30 />,
    label: "ساعت",
  },
  {
    icon: <IconDeviceFloppy />,
    label: "ثبت",
  },
];

export type selectedTimeCapacity = {
  id: number;
  title: string;
  capacity: number;
};
